import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserAppData } from '../../../api/userApi';
import TickerSearch from '../../../modules/Search/TickerSearch/TickerSearch';
import ItemTable from './ItemTable';
import SelectedItems from './SelectedItems';
import { loadSectorsIndustries } from '../../../store/slices/globalResources.slice';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { SaveRounded } from "@mui/icons-material";
import { Row, Tabs, Typography, Card } from 'antd';
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const BlacklistInstance = ({ blacklist, onClose }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const [title, setTitle] = useState(blacklist?.title || 'New Blacklist');

  const sectorList = useSelector(state => state.global.cache?.sectorsIndustries?.sector);
  const industryList = useSelector(state => state.global.cache?.sectorsIndustries?.industry);
  const subIndustryList = useSelector(state => state.global.cache?.sectorsIndustries?.sub_idustry);

  useEffect(() => {
    if (!sectorList || sectorList.length === 0) {
      dispatch(loadSectorsIndustries());
    }
  }, [dispatch, sectorList]);

  const [selectedItems, setSelectedItems] = useState({
    sectors: [],
    industries: [],
    tickers: [],
    ...blacklist?.data,
  });

  const handleAddItem = (type, item) => {
    setSelectedItems(prevItems => {
      if (prevItems[type]?.includes(item)) {
        return prevItems; // Return unchanged state if item already exists
      }
      return {
        ...prevItems,
        [type]: [...(prevItems[type] || []), item],
      };
    });
  };

  const handleRemoveItem = (type, itemToRemove) => {
    setSelectedItems(prevItems => ({
      ...prevItems,
      [type]: prevItems[type].filter(item => item !== itemToRemove),
    }));
  };

  const handleSaveBlacklist = () => {
    dispatch(saveUserAppData({
      appType: 'blacklist',
      title,
      data: selectedItems,
      id: blacklist?.id,
    }));
  };

  return (
    <Card>
      <Row align={'middle'} justify={'space-between'}>
        <Title editable={{ onChange: setTitle }} level={3}>{title}</Title>
        <ButtonGroup>
          <Button startIcon={<SaveRounded />} variant={'contained'} onClick={handleSaveBlacklist} type="primary">
            Save Blacklist
          </Button>
          <Button onClick={onClose}>
            Cancel
          </Button>
        </ButtonGroup>
      </Row>
      <div className={'my-5 p-3 bordered-dash'}>
        <Typography.Text strong className={'p-1'}>Selected Items</Typography.Text>
        <SelectedItems items={selectedItems} onRemove={handleRemoveItem} />
      </div>
      <Tabs type="card">
        <TabPane tab="Tickers" key="1">
          <TickerSearch onTickersSubmit={(tickers) => {
            tickers.forEach(ticker => handleAddItem('tickers', ticker.symbol));
          }} />
        </TabPane>
        <TabPane tab="Sectors" key="2">
          <ItemTable
            selectedItems={selectedItems}
            onAdd={handleAddItem}
            onRemove={handleRemoveItem}
            sectors={sectorList}
            industries={industryList}
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default BlacklistInstance;
